import { render, staticRenderFns } from "./c_home_tab.vue?vue&type=template&id=573d86c7&scoped=true"
import script from "./c_home_tab.vue?vue&type=script&lang=js"
export * from "./c_home_tab.vue?vue&type=script&lang=js"
import style0 from "./c_home_tab.vue?vue&type=style&index=0&id=573d86c7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d86c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573d86c7')) {
      api.createRecord('573d86c7', component.options)
    } else {
      api.reload('573d86c7', component.options)
    }
    module.hot.accept("./c_home_tab.vue?vue&type=template&id=573d86c7&scoped=true", function () {
      api.rerender('573d86c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_home_tab.vue"
export default component.exports